import React from "react"
import { graphql } from "gatsby"

import { PrivacySupplementQuery, ContentfulPage } from "../../types/graphql-types"
import Page, { NavSpacer } from "../components/page"
import { SingleColumnContainer, Column } from "../components/layout"
import GenericSections from "../components/genericSections"

interface Props {
  data: PrivacySupplementQuery
}

const PrivacySupplement = ({ data }: Props) => (
  <Page title="Privacy Supplement" metadata={data.page?.metadata} hasBottomMargin>
    <NavSpacer />
    <SingleColumnContainer>
      <Column leftSpanDesk={2} rightSpanDesk={2} center>
        <h1>{data.page?.heading?.heading}</h1>
      </Column>
    </SingleColumnContainer>
    <SingleColumnContainer>
      <Column leftSpanDesk={2} rightSpanDesk={2}>
        <GenericSections page={data.page as ContentfulPage} />
      </Column>
    </SingleColumnContainer>
  </Page>
)

export default PrivacySupplement

export const pageQuery = graphql`
  query PrivacySupplement($locale: String = "en") {
    page: contentfulPage(
      label: { eq: "HMD Connect Privacy Supplement" }
      node_locale: { eq: $locale }
    ) {
      ...GenericPage
    }
  }
`
